import { defaultSwiperSettings } from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import "swiper/dist/css/swiper.css";
import Vue from "vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Component from "vue-class-component";
import { Emit, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    swiper,
    swiperSlide
  }
})
export default class SwiperSettings extends Vue {
  @Action("setMobilePage", navigationNamespace)
  setMobilePage!: Function;

  @Getter("mobilePage", navigationNamespace)
  mobilePage!: number;

  @Getter("singlePatientView", patientNamespace)
  singlePatientView!: boolean;

  @Watch("mobilePage")
  mobilePageChange(to: number, from: number) {
    const swiperRef = this.$refs.swiper.swiper;
    if (swiperRef.activeIndex !== to) {
      swiperRef.slideTo(to);
    }
  }

  swiperOption = Object.assign(defaultSwiperSettings, {
    initialSlide: 1
  });

  $refs!: {
    swiper: any;
  };

  @Emit()
  back() {}

  mounted() {
    const swiperRef = this.$refs.swiper.swiper;
    if (swiperRef) {
      // single patient should not be able to swipe back to census
      this.handleSinglePatientView(swiperRef);
    }
  }

  slideChange() {
    const swiperRef = this.$refs.swiper.swiper;
    if (swiperRef) {
      this.setMobilePage(swiperRef.realIndex);

      this.handleSinglePatientView(swiperRef);

      if (swiperRef.realIndex === 0) {
        this.back();
      }
      if (swiperRef.slides.length - 1 === swiperRef.realIndex) {
        swiperRef.allowSlideNext = false;
      } else {
        swiperRef.allowSlideNext = true;
      }
    }
  }

  // single patient should not be able to swipe back to census
  private handleSinglePatientView(swiperRef: any) {
    if (swiperRef.realIndex === 1 && this.singlePatientView) {
      swiperRef.allowSlidePrev = false;
    } else {
      swiperRef.allowSlidePrev = true;
    }
  }
}
